import { timeZoneContext } from "helpers/contexts";
import { useContext } from "react";

export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default function useTimeZone() {
  const { timeZone, defaultTimeZone } = useContext(timeZoneContext) || {};
  return timeZone || defaultTimeZone || LOCAL_TIMEZONE;
}
